module.exports = __webpack_public_path__ + "static/office_small_green_2-fe7f27e4e407e5ee80fd9c5744803c74.jpg";